import { msg } from 'gt-react';

export const EXCEPTION_RULES_CRUMB = msg('Exception Rules', {
  context: 'page breadcrumb',
});

export const NEW_RULE_SET_CRUMB = msg('New Exception Rule Set', {
  context: 'page breadcrumb when creating a rule set',
});

export const RULE_SET_CRUMB_FALLBACK = msg('Exception Rule Set', {
  context: 'breadcrumb fallback when the rule set name is unknown',
});

export const EDIT_RULE_SET_CRUMB = msg('Edit', {
  context: 'breadcrumb for the edit page of an exception rule set',
});

export const EXCEPTION_RULES_PATH = '/accounts-payable/exception-rules';

export type ExceptionRuleSetCrumbs = {
  crumb: string;
  crumbAncestors: Array<{ title: string; path: string }>;
};

function exceptionRulesAncestor() {
  return { title: EXCEPTION_RULES_CRUMB, path: EXCEPTION_RULES_PATH };
}

/** Exception Rules > New Exception Rule Set */
export function newRuleSetCrumbs(): ExceptionRuleSetCrumbs {
  return {
    crumb: NEW_RULE_SET_CRUMB,
    crumbAncestors: [exceptionRulesAncestor()],
  };
}

/** A failed lookup degrades to a fallback crumb rather than failing the route. */
export async function settleLookup<T>(promise: Promise<T>): Promise<T | null> {
  try {
    return await promise;
  } catch {
    return null;
  }
}

function ruleSetTitle(name: string | undefined): string {
  const trimmed = name?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : RULE_SET_CRUMB_FALLBACK;
}

/** Exception Rules > {name | Exception Rule Set} */
export function viewRuleSetCrumbs(
  name: string | undefined,
): ExceptionRuleSetCrumbs {
  return {
    crumb: ruleSetTitle(name),
    crumbAncestors: [exceptionRulesAncestor()],
  };
}

/** Exception Rules > {name} > Edit */
export function editExistingRuleSetCrumbs(
  name: string | undefined,
  ruleSetId: string,
): ExceptionRuleSetCrumbs {
  return {
    crumb: EDIT_RULE_SET_CRUMB,
    crumbAncestors: [
      exceptionRulesAncestor(),
      {
        title: ruleSetTitle(name),
        path: `${EXCEPTION_RULES_PATH}/${ruleSetId}`,
      },
    ],
  };
}
